import { sha256 } from "js-sha256";
import React, { Fragment, useContext, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../components/AppProvider";
import { InputDiv } from "../../components/UI/INPUT/InputDiv";
import { PostApi158 } from "../../modules/network/padoPost";
import { _CHECK, _O } from "../../modules/utils";
import { AlertPopup, ContainerNew, openAlertPopup } from "../Layout";

export default props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [next, setNext] = useState(false);

  const request158 = userPswdNo => {
    const newPwd = sha256(
      props.match.params.userId.trim() + "eocs" + userPswdNo
    );

    PostApi158(
      phonecfg,
      cfg,
      props.match.params.userId,
      newPwd,
      props.match.params.attctNo
    ).then(res => {
      if (res.resultCode === "000") {
        if (res.result === 0) {
          // handleAlert('', '성공');
          setNext(false);
          openAlertPopup("잘못된 비밀번호입니다.");
        } else {
          setNext(true);
          openAlertPopup("변경된 정보로 다시 로그인 하세요.");
          // if (!userinfo || userinfo == "" || userinfo.userToken == "") {
          // _O.OpenMenu("/membership/loginAccount/" + props.match.params.userId);
          // } else {
          // _O.Open("/membership/chkPw");
          // }
          // 인증번호가 잘못되었을경우 인증번호 발송이후 회원정보가 바뀐 경우
        }
      } else {
        handleNewPasswordFail();
      }
    });
  };

  const fnChangePwd = (password, rePassword) => {
    if (_CHECK.PwdValidate(password, rePassword)) {
      request158(password);
    }
  };

  const bottom = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}>
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          fnChangePwd(
            $("input[name=newPw]").val(),
            $("input[name=newRePw]").val()
          );
        }}>
        확인
      </BtnNext>
    </div>
  );

  return (
    <Fragment>
      <ContainerNew
        Title={"본인인증"}
        dark={"dark"}
        rightMenu={-1}
        bottom={bottom}
        isMain={true}
        leftMenu={1}>
        <Contents>
          <SubTitleCpnt /> {/* input area */}
          <div>
            <DivTitle>새 비밀번호</DivTitle>
            <InputDiv
              type="password"
              name="newPw"
              placeholder="5~16자의 영어, 숫자"
              maxLength={16}
              style={{
                marginBottom: "16px",
                backgroundColor: "#f7f7f7",
                borderRadious: "8px",
              }}
            />

            <DivTitle>비밀번호 확인</DivTitle>
            <InputDiv
              type="password"
              name="newRePw"
              placeholder="5~16자의 영어, 숫자"
              maxLength={16}
              style={{
                marginBottom: "16px",
                backgroundColor: "#f7f7f7",
                borderRadious: "8px",
              }}
            />
          </div>
        </Contents>
      </ContainerNew>
      <AlertPopup
        clickEvent={
          next ? "/membership/loginAccount/" + props.match.params.userId : false
        }
      />
    </Fragment>
  );
};

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const SubTitleCpnt = () => {
  return (
    <Fragment>
      <SubTitle>비밀번호 재설정</SubTitle>
      <div style={{ padding: "8px 0px" }} />
    </Fragment>
  );
};

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;

const DivTitle = styled.div`
  padding-left: 4px;
  font-weight: 700;
  margin-bottom: 4px;
`;

const BtnNext = styled.div`
  bottom: 86px;
  width: ${props => window.innerWidth - 30}px;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;
